var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-layout',[_c('div',{staticClass:"page"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }